import React from 'react';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import classes from './Notification.module.css';
import { get } from "../../utils/api";
import Config from "../../Kneura-Web-Whiteboard/IWB/config";
import { getTime,isRecentNotification } from './notificationutils';
import { getKneuraId, setBoardInfo,getInstituteKneuraId } from '../../utils/authentication-access';
import { withTranslation } from 'react-i18next';

class LessonPathNotification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			notificationtime: "Just Now",
			isNew:false
		};
	}

	componentDidMount() {
		this.setState({ notificationtime: getTime(this.props.info.createdAt) });
		this.setState({ isNew: isRecentNotification(this.props.info.createdAt) });
	}

	showLessonPlan = () => {

		var url = Config.flowItemURL + this.props.info.flowId;
		 let self = this;
		  get(url, {
			headers: {
			  "Content-Type": "application/json",
			  institute_id: getInstituteKneuraId()
			}
		  })
			.then(async response => {
				let info = {
					name: this.props.info.name,
					flow_id: this.props.info.flowId,
					isOnline: false,
					isPublic: true,
					class_id: this.props.info.classCode,
					user_id: getKneuraId()
				};
				setBoardInfo(info);
				this.props.history.push('/class');
			})
			.catch(err => {
				self.props.showMessage("Unable to open lesson");
			});	
		
	};

	render() {
		const { t } = this.props;
		return (
			<div className={classes.MesGrid}>
				<Grid container direction="row" justify="space-between" alignItems="flex-start" wrap="nowrap">
					<div className={ this.state.isNew ? classes.newNotificationMesHeader : classes.notificationMesHeader}>{this.props.info.className}</div>
					<div className={ this.state.isNew ? classes.newNotificationDateMesHeader:classes.notificationDateMesHeader}>{this.state.notificationtime}</div>
				</Grid>
				<div className={classes.notificationMes} onClick={this.showLessonPlan}>
					<b>{this.props.info.teacherName} </b> {t("published a new lesson")} : <b>{this.props.info.name}</b>
				</div>
				<div className={this.state.isNew ? classes.NewMesDivider : classes.MesDivider} />
			</div>
		);
	}
}

export default withTranslation()(LessonPathNotification);
